class EventEditPageController {

  constructor($state, $stateParams, AlertService, RacedaysService, EventService, LocationService, LoaderService, Upload) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.AlertService = AlertService;
    this.RacedaysService = RacedaysService;
    this.EventService = EventService;
    this.LocationService = LocationService;
    this.LoaderService = LoaderService;
    this.Upload = Upload;
  }

  $onInit() {
    var self = this;
    self.files = {
      'header': null,
      'dynamicLink1': null,
      'dynamicLink2': null
    };
    self.filesToRemove = {
      'header': false,
      'dynamicLink1': false,
      'dynamicLink2': false
    };
    self.imageEndpoint = "/api/upload";
    self.eventId = self.$stateParams.eventId;
    self.racedayId = self.$stateParams.id;
  }

  deleteEvent(eventId) {
    if (confirm("Are you sure? This cannot be undone.")) {
      var self = this;
      self.EventService.deleteEvent(eventId, self.racedayId)
        .then(() => {
          self.AlertService.success("Event has been deleted");
          self.$state.go('app.racedays.raceday.edit');
        })
        .catch((error) => self.AlertService.error('There was an error deleting this event'));
    }
  }

  /**
   * Store file when chosen
   * @param picFile
   * @param type
   */
  storeFile(picFile, type) {
    this.files[type] = picFile;
  }

  removeFile(type) {
    this.filesToRemove[type] = true;
  }

  save() {
    var self = this;

    if (!self.validForm()) {
      self.AlertService.error("The form has validation errors.");
      return;
    }

    self.LoaderService.start();
    self.EventService.update(self.event, self.racedayId, self.files, self.filesToRemove)
      .then(() => {
        // empty the file array
        self.files = {};
        self.AlertService.success("Event has been updated");
        self.$state.go('app.racedays.raceday.edit');
      }
      )
      .catch((error) => {
        if (error.type === 'image') {
          self.validation = {};
          if (error.field === 'header') {
            self.files.raceday = null;
            self.validation.headerImage = error.message;
          }
          if (error.field === 'dynamicLink1') {
            self.files.dynamicLink1 = null;
            self.validation.dynamicLink1Image = error.message;
          }
          if (error.field === 'dynamicLink2') {
            self.files.dynamicLink2 = null;
            self.validation.dynamicLink2Image = error.message;
          }
          self.AlertService.error("There was a problem saving one or more of the event images.");
          // empty the file array
          self.files = {};
        }
        else {
          self.AlertService.error("There was a problem saving the Event");
        }
      })
      .finally(() => {
        self.LoaderService.stop();
      });
  }

  validForm() {
    var self = this;
    //validation

    self.validation = {};

    if (self.event.name === undefined || self.event.name === '') {
      self.validation.name = 'Event Title is required';
    }
    if (self.event.location === undefined || self.event.location === null) {
      self.validation.location = 'Location is required';
    }

    //time req expr
    var re = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;

    if (self.event.startTime === undefined || self.event.startTime === '') {
      self.validation.startTime = 'Start Time is required';
    }
    else {
      if (!re.test(self.event.startTime)) {
        self.validation.startTime = 'Enter as hh:mm';
      }
    }


    if (self.event.description === undefined || self.event.description === '') {
      self.validation.description = 'Location Description is required';
    }

    if ((!!self.event.dynamicLink1.url.trim() && !self.event.dynamicLink1.name.trim()) || (!!self.event.dynamicLink1.name.trim() && !self.event.dynamicLink1.url.trim())) {
      self.validation.dynamicLink1 = 'If using a dynamic link, both name and URL are required';
    } else if (self.event.dynamicLink1.url.length > 0 && !self.event.dynamicLink1.url.startsWith("http://") && !self.event.dynamicLink1.url.startsWith("https://")) {
      self.validation.dynamicLink1 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if ((!!self.event.dynamicLink2.url.trim() && !self.event.dynamicLink2.name.trim()) || (!!self.event.dynamicLink2.name.trim() && !self.event.dynamicLink2.url.trim())) {
      self.validation.dynamicLink2 = 'If using a dynamic link, both name and URL are required';
    } else if (self.event.dynamicLink2.url.length > 0 && !self.event.dynamicLink2.url.startsWith("http://") && !self.event.dynamicLink2.url.startsWith("https://")) {
      self.validation.dynamicLink2 = 'Please ensure dynamic link URL starts with http:// or https://';
    }

    if (self.isEmpty(self.validation)) {
      return true;
    }
    else {
      return false;
    }

  }

  isEmpty(obj) {
    if (obj == null) return true;
    if (obj.length > 0) return false;
    if (obj.length === 0) return true;
    if (typeof obj !== "object") return true;
    for (var key in obj) {
      if (hasOwnProperty.call(obj, key)) return false;
    }
    return true;
  }
}
EventEditPageController.$inject = ['$state', '$stateParams', 'AlertService', 'RacedaysService', 'EventService', 'LocationService', 'LoaderService', 'Upload'];
export default EventEditPageController;
